import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Sun, Moon, Grid3x3, Compass, Plus, Mail } from 'lucide-react';
import SearchAutocomplete from './SearchAutocomplete';

export default function SiteHeader({ theme, toggleTheme }) {
  const { pathname } = useLocation();
  return (
    <header className="nav">
      <div className="nav-inner">
        <Link to="/" className="nav-brand">AI Framework</Link>
        <nav className="nav-links">
          <Link to="/" className={pathname === '/' || pathname === '/tree' ? 'active' : ''}>
            Tree
          </Link>
          <Link to="/browse" className={pathname.startsWith('/browse') || pathname.startsWith('/category') ? 'active' : ''}>
            <Grid3x3 size={12} style={{ marginRight: 4, verticalAlign: '-2px' }} />
            Directory
          </Link>
          <Link to="/discover" className={pathname.startsWith('/discover') ? 'active' : ''}>
            <Compass size={12} style={{ marginRight: 4, verticalAlign: '-2px' }} />
            Discover
          </Link>
          <Link to="/submit" className={pathname.startsWith('/submit') ? 'active' : ''} data-testid="nav-submit">
            <Plus size={12} style={{ marginRight: 4, verticalAlign: '-2px' }} />
            Submit
          </Link>
          <Link to="/contact" className={pathname.startsWith('/contact') ? 'active' : ''} data-testid="nav-contact">
            <Mail size={12} style={{ marginRight: 4, verticalAlign: '-2px' }} />
            Contact
          </Link>
        </nav>
        <div className="nav-actions">
          <div className="nav-search">
            <SearchAutocomplete variant="nav" placeholder="Search…" />
          </div>
          <button className="pill-btn ghost" onClick={toggleTheme} type="button" aria-label="Toggle theme">
            {theme === 'dark' ? <Sun size={14} /> : <Moon size={14} />}
          </button>
        </div>
      </div>
    </header>
  );
}
